import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Common.css";
import LiveBackdrop from "./LiveBackdrop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="siteFrame">
      <LiveBackdrop />
      <App />
    </div>
  </React.StrictMode>
);

reportWebVitals();
